import * as React from 'react';
import { path, pathOr } from 'ramda';
import { InputAdornment } from '@cian/ui-kit';

import { IBaseQuestionProps } from '../FormContainer/types/internal';
import { QuestionLayoutContainer } from '../QuestionLayoutContainer';
import { useFormTracking } from '../../utils/useFormTracking';
import { FormInputsLayout } from '../../components/FormInputsLayout';

export const RawStringQuestionContainer: React.FC<React.PropsWithChildren<IBaseQuestionProps>> = props => {
  const { trackSubmit, trackChange } = useFormTracking();
  const {
    question: { answerField, placeholder, unit, required, title, helpText },
    setAnswer,
    answersState,
    setNextStep,
  } = props;

  const handleSubmit = React.useCallback(() => {
    setNextStep(answersState);
    trackSubmit({
      isRequired: required,
      value: pathOr('', [answerField, 'value'], answersState),
      field: answerField,
    });
  }, [trackSubmit, answersState, setNextStep, answerField, required]);

  const handleChange = React.useCallback<NonNullable<React.ComponentProps<'input'>['onChange']>>(
    e => {
      setAnswer({ answerField, value: e.target.value });
      trackChange();
    },
    [setAnswer, answerField, trackChange],
  );

  const isNextBtnDisabled = required && !path([answerField, 'value'], answersState);

  return (
    <QuestionLayoutContainer
      title={title}
      onSubmit={handleSubmit}
      disableSubmit={isNextBtnDisabled}
      buttonText={props.submitButtonText}
      error={props.error}
      showButtonPreloader={props.showButtonPreloader}
      description={helpText?.text}
    >
      <FormInputsLayout
        InputProps={{
          type: 'text',
          placeholder: placeholder || '',
          onChange: handleChange,
          value: pathOr('', [answerField, 'value'], answersState),
          rightAdornment: <InputAdornment>{unit}</InputAdornment>,
          name: answerField,
        }}
        fullwidth
      />
    </QuestionLayoutContainer>
  );
};

RawStringQuestionContainer.displayName = 'RawStringQuestionContainer';
